// ABOUTME: The standard visually-hidden style (readable by screen readers, invisible on screen) as an MUI sx object.
// ABOUTME: Shared by the runner's live region and its rail's spoken state labels.

export const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
} as const;
